
function NewFiscalScorecardController(config) {
    this.config = config;
}

module.controller('NewFiscalScorecardController', NewFiscalScorecardController)
